import React, { useCallback, useMemo, useState } from 'react'
import './about-spare.scss'
import SpinWithMessage from '../../common/spinners/SpinWithMessage'
import { FaDotCircle } from 'react-icons/fa'
import { customerAxios } from '../../../config/axios'
import toast from 'react-hot-toast'
import CUSpare from './CUSpare'
import Modal from '../../common/modal/Modal'
import UpdatePackageRate from './UpdatePackageRate'

const AboutSpare = ({ spareId }) => {
    const [loading, setLoading] = useState('')
    const [data, setData] = useState({})
    const [modal, setModal] = useState({})

    const res = useMemo(() => {
        setLoading('fetch')
        customerAxios.get(`/production-v0/spare/${spareId}`)
            .then((response) => {
                setData(response.data || {})
                setLoading('')
            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })

    }, [spareId])

    const openEditModel = () => {
        setModal({
            status: true, title: "Edit spare", width: '600px',
            content: <CUSpare currentData={data} setModal={setModal} setData={setData} isEdit={true} />
        })
    }

    const openPackageRateModel = () => {
        setModal({
            status: true, title: "Update Package Rate", width: '600px',
            content: <UpdatePackageRate spare_id={data?.spare_id} currentData={data?.package_prices} setModal={setModal} />
        })
    }

    const handleChangeStatus = () => {
        const ask = window.confirm(`Are you ready to ${data?.is_active ? 'Inactive' : "Active"} ?`)

        if (ask) {
            customerAxios.patch(`/production-v0/spare/${data?.spare_id}/status`, {
                is_active: data?.is_active ? false : true
            }).then(() => {
                setModal({ status: false })
                toast.success(`Spare Status Updated!`)

                setData({
                    ...data,
                    is_active: data?.is_active ? false : true
                })

            }).catch((error) => {
                toast.error(error.message)
            })
        }
    }

    return (
        loading === 'fetch'
            ? <SpinWithMessage message='Loading...' height={'250px'} />
            : <div className="about-spare-container">
                <Modal modal={modal} setModal={setModal} />
                <div className="buttons">
                    <button onClick={() => openEditModel()}>Edit Spare</button>
                    <button onClick={() => openPackageRateModel()}>Edit Package Price</button>
                    <button style={{ backgroundColor: data?.is_active ? 'red' : "green" }} onClick={handleChangeStatus}>
                        {data?.is_active ? 'Deactivate' : "Activate"}
                    </button>
                </div>

                <div className="list-border-div">
                    <div className="list-title">
                        <h4>Spare</h4>
                    </div>
                    <div className="title-content">
                        <div className="list-div">
                            <div className="one-div">
                                <p>Spare ID</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.spare_id}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Spare Name</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.spare_name}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Applicable For</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.applicable_for}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Unit Type</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.unit}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Spare Category</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.spare_category}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Selling Rate (SR)</p>
                            </div>
                            <div className="two-div">
                                <p>: ₹{data?.selling_rate}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Purchase Cost (PC)</p>
                            </div>
                            <div className="two-div">
                                <p>: ₹{data?.purchase_cost}</p>
                            </div>
                        </div>
                        <div className="list-div">
                            <div className="one-div">
                                <p>Warranty</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.default_warranty_period ? `${data?.default_warranty_period || 0} Months` : 'Nil'}</p>
                            </div>
                        </div>
                        <div className="list-div credit-amt">
                            <div className="one-div">
                                <p>Spare Status</p>
                            </div>
                            <div className="two-div">
                                <p>: {data?.is_active ? 'ACTIVE' : "INACTIVE"}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="list-border-div">
                    <div className="list-title">
                        <h4>Attributes</h4>
                    </div>
                    {data?.attributes?.length > 0
                        ? <>
                            <div className="title-content">
                                {data?.attributes?.map((att) => {
                                    return <div className="list-div">
                                        <div className="one-div">
                                            <p>{att?.feature_id}</p>
                                        </div>
                                        <div className="two-div">
                                            <p>: {att?.value}</p>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </>
                        : <p>Nil</p>}

                </div>

                <div className="list-border-div">
                    <div className="list-title">
                        <h4>Package Prices (P2)</h4>
                    </div>
                    {data?.package_prices?.length > 0
                        ? <>
                            <div className="title-content">
                                {data?.package_prices?.map((pp) => {
                                    return <div className="list-div">
                                        <div className="one-div">
                                            <p>{pp?.package_name}</p>
                                        </div>
                                        <div className="two-div">
                                            <p>: {pp?.price}</p>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </>
                        : <p>Nil</p>}
                </div>

                <div className="list-border-div">
                    <div className="list-title">
                        <h4>Inner Items</h4>
                    </div>
                    {data?.item_list?.length > 0
                        ? <>
                            <div className="title-content">
                                {data?.item_list?.map((sp) => {
                                    return <div className="list-div">
                                        <div className="one-div">
                                            <p>{sp?.spare_id}</p>
                                        </div>
                                        <div className="two-div">
                                            <p>: {sp?.spare_name} (Qty : {sp?.qty})</p>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </>
                        : <p>Nil</p>}
                </div>

            </div>
    )
}

export default AboutSpare